import { z } from 'zod';

export type AiPromptFilters = {
  clientId?: string;
  postPlatformId?: string;
};

export const aiMessageSchema = z.object({
  id: z.string(),
  role: z.enum(['user', 'assistant']),
  message: z.unknown(),
  createdAt: z.coerce.date(),
  status: z.enum(['pending', 'generating', 'failed', 'success']).nullable().optional(),
  readAt: z.coerce.date().nullable().optional(),
});

export const aiPromptSchema = z.object({
  id: z.string(),
  title: z.string().nullable().optional(),
  filters: z
    .object({
      clientId: z.string().optional(),
      postPlatformId: z.string().optional(),
    })
    .nullable()
    .optional(),
  userGenerated: z.boolean(),
  userId: z.string(),
  agencyId: z.string().nullable().optional(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  messages: z.array(aiMessageSchema),
});

export type AiPromptSchema = z.infer<typeof aiPromptSchema>;
export type AiMessageSchema = z.infer<typeof aiMessageSchema>;
